<template>
  <!-- 右侧推荐 -->
  <div class="appleRight">
    <div class="appleRightTop">
      <div class="love-two-title">
        <div class="text">
          <slot>猜你喜欢</slot>
          <img
            class="icon"
            src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/tips.png"
          />
        </div>
      </div>

      <div
        v-for="(item, index) in list"
        :key="index"
        class="appleRightTopb"
        @click="detail(item)"
      >
        <div class="appleRightTopbs pointer">
          <img class="img" :src="item.coachClassTypeImage" />
          <div class="appleRightTopbsR">
            <div class="title twoEllipsis">
              {{
                item.coachClassTypeName  
              }}
            </div>
            <!-- <div v-if="ifteacher" class="detail-ter m-t-12 flex-c">
              <div class="ter-list">
                <div class="terbox">
                  <el-image class="ter-img" :src="item ? item.tImg : ''" fit="cover" />
                </div>
                <span class="ter">讲师：{{ item.terName }}</span>
              </div>
            </div>  -->
            <span class="price"
              >¥
              {{
                item.coachClassTypePrice ? item.coachClassTypePrice : 0
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDomain } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  props: ["lineType", "id", "belongMajor"],
  data() {
    return {
      list: [],
      domainInfo: {},
    };
  },
  created() {
    this.domainInfo = getDomain();
    homeClient
      .qbsJxyTutorial({
        lineType: this.lineType,
        majorId: this.belongMajor,
        pageNum: 1,
        pageSize: 5,
      })
      .then((res) => {
        this.list = res.rows;
      });
  },

  methods: {
    // 跳转
    detail(row) {
      if (row.lineType == 3) {
        this.$router.push(`/VIP/VIPClassxq?id=${row.coachClassTypeId}`);
      } else {
        this.$router.push(`/typeclassxq?id=${row.coachClassTypeId}`);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.appleRight {
  width: 320px;
  height: fit-content;
  background: #ffffff;
  border-radius: 6px;

  .appleRightTop {
    width: 280px;
    height: auto;
    margin: 20px auto;

    .appleRightTopb {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .appleRightTopbs {
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 24px;

        .img {
          margin-top: 8px;
          margin-right: 12px;
          width: 120px;
          height: 67.5px;
          background: #c4c4c4;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          flex-shrink: 0;
        }

        .appleRightTopbsR {
          width: 145px;
          height: 70px;

          .title {
            height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .clicks {
            font-size: 14px;
            color: #999;
          }

          .price {
            font-size: 18px;
            color: #f15817;
          }
        }
      }
    }
  }

  .appleRightCen {
    width: 100%;
    height: 20px;
    background: #f5f6fa;
  }

  .appleRightBtm {
    width: 280px;
    height: 200px;
    margin: auto;

    .appleRightBtma {
      margin-top: 20px;
      width: 100%;
      height: 20px;
      border-left: 3px solid #009aff;
      font-size: 18px;
      color: #333;
      margin-bottom: 2px;
      padding-left: 8px;
      line-height: 18px;
    }

    .appleRightBtmb {
      width: 100%;
      height: 144px;
      display: flex;
      margin-top: 30px;

      .appleRightBtmbs {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        img {
          width: 100px;
          height: 100px;
        }

        p {
          width: 100%;
          height: 34px;
          font-size: 14px;
          color: #626262;
          line-height: 34px;
          text-align: center;
        }
      }
    }
  }
}

/* 列表-讲师 */
.detail-ter {
  .ter-list {
    display: flex;
    align-items: center;

    .terbox {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 8px;
      background: #a8abbe;
      border: none;
      overflow: hidden;
    }

    .ter-img {
      width: 24px;
    }

    .ter {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 14px;
    }
  }
}
</style>
